/* eslint-disable no-case-declarations */
// reducers/authenticationReducer.js

import { LOG_IN, USERS_UPDATE_ME, LOG_OUT } from "../actions/actionTypes";
import initialState from "./initialState";

export default function(state = initialState.authentication, action) {
  switch (action.type) {
    case LOG_IN:
    case USERS_UPDATE_ME:
      const newState = {
        ...state,
        user: action.payload
      };
      return newState;
    case LOG_OUT:
      return initialState.authentication;
    default:
      return state;
  }
}
